import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type { Pos } from '../model/pos';

export type GetPosParams = {
  withInactive: boolean;
};

export async function getPos({ withInactive }: GetPosParams): Promise<Pos[]> {
  const res = await makeRequest<{ payload: Pos[] }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v1/public/point-of-sales/find-all-by-employee-id`,
    withCredentials: true,
    timeout: 60_000,
    payload: { withInactive },
  });
  return res.payload;
}
